// School statuses
export const SCHOOL_STATUSES = [
  { value: 'live', label: 'Live' },
  { value: 'waitlist', label: 'Waitlist' },
  { value: 'suspended', label: 'Suspended' },
] as const;

// Lite levels
export const LITE_LEVELS = [
  { value: 'L1', label: 'Level 1' },
  { value: 'L2', label: 'Level 2' },
  { value: 'L3', label: 'Level 3' },
] as const;

// Countries
export const COUNTRIES = [
  { value: 'US', label: '🇺🇸 United States' },
  { value: 'CA', label: '🇨🇦 Canada' },
] as const;

// U.S. States
export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  DC: 'Washington D.C.',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
} as const;

// Canadian Provinces and Territories
export const CANADIAN_PROVINCES = {
  ON: 'Ontario',
  QC: 'Quebec',
  NS: 'Nova Scotia',
  NB: 'New Brunswick',
  MB: 'Manitoba',
  BC: 'British Columbia',
  PE: 'Prince Edward Island',
  SK: 'Saskatchewan',
  AB: 'Alberta',
  NL: 'Newfoundland and Labrador',
  NT: 'Northwest Territories',
  YT: 'Yukon',
  NU: 'Nunavut',
} as const;

// Get states/provinces by country
export function getStatesByCountry(country: 'US' | 'CA') {
  return country === 'CA' ? CANADIAN_PROVINCES : US_STATES;
}

// Convert states object to select options
export function getStateOptions(country: 'US' | 'CA') {
  const states = getStatesByCountry(country);
  return Object.entries(states).map(([value, label]) => ({
    value,
    label,
  }));
}

// Color swatches for primary color picker (from old dashboard)
export const COLOR_SWATCHES = [
  { value: '#F82A60', label: 'Red' },
  { value: '#FD793C', label: 'Orange' },
  { value: '#9CD9FB', label: 'Light Blue' },
  { value: '#A61E3F', label: 'Maroon' },
  { value: '#FFC942', label: 'Yellow' },
  { value: '#D1A73A', label: 'Gold' },
  { value: '#13B87C', label: 'Green' },
  { value: '#397BFA', label: 'Royal Blue' },
  { value: '#2750AE', label: 'Navy' },
  { value: '#444444', label: 'Black' },
  { value: '#B7B4B4', label: 'Gray' },
  { value: '#8B46FF', label: 'Purple' },
  { value: '#AF6622', label: 'Brown' },
] as const;

// Schedule types
export type ScheduleType =
  | 'multiple_day_rotating'
  | 'same_every_day'
  | 'a_b'
  | 'a_b_plus'
  | 'monday_through_friday'
  | 'other'
  | 'same_every_day_plus';

export const SCHEDULE_TYPES = [
  { value: 'multiple_day_rotating', label: 'MDR (Multi-Day Rotating)' },
  { value: 'same_every_day', label: 'Same Every Day' },
  { value: 'same_every_day_plus', label: 'Same Every Day+' },
  { value: 'a_b', label: 'A/B' },
  { value: 'a_b_plus', label: 'A/B+' },
  { value: 'monday_through_friday', label: 'Monday through Friday' },
  { value: 'other', label: 'Other' },
] as const;

// Lunch types
export type LunchType = 'unit' | 'class' | 'waves';

export const LUNCH_TYPES = [
  { value: 'unit', label: 'Unit Lunch' },
  { value: 'class', label: 'Class Lunch' },
  { value: 'waves', label: 'Lunch Waves' },
] as const;

// Timezones (US & Canada)
export const TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Vancouver',
  'America/Edmonton',
  'America/Winnipeg',
  'America/Halifax',
  'America/St_Johns',
  'America/Regina',
] as const;

